import { motion } from "framer-motion";
import Reveal, { CmykDots } from "@/components/Reveal";

const VIDEOS = [
  { src: "/videos/press-1.mp4", label: "Floor cam 01" },
  { src: "/videos/press-2.mp4", label: "Floor cam 02" },
  { src: "/videos/press-3.mp4", label: "Floor cam 03" },
];

export default function VideoSection() {
  return (
    <section id="press" className="py-20 lg:py-28 bg-surface/40 border-y border-edge" data-testid="press-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyanbrand">
              / Inside the press
            </span>
            <h2 className="mt-4 font-display font-semibold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-paper">
              Watch the machines run.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <CmykDots />
            <span className="font-mono text-[11px] tracking-[0.2em] text-mist">LIVE FROM OUR FLOOR</span>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.src}
              data-testid={`press-video-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="relative overflow-hidden border border-edge bg-ink rounded-sm group"
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                className="w-full aspect-[9/16] object-cover saturate-[0.9] group-hover:scale-[1.03] transition-transform duration-700"
                aria-label={`Print shop floor video ${i + 1}`}
              >
                <source src={v.src.replace(".mp4", ".webm")} type="video/webm" />
                <source src={v.src} type="video/mp4" />
              </video>
              <figcaption className="absolute bottom-0 inset-x-0 flex items-center justify-between px-4 py-3 bg-gradient-to-t from-ink/80 to-transparent">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/80">{v.label}</span>
                <span className="w-2 h-2 rounded-full bg-mag animate-pulse" aria-hidden="true" />
              </figcaption>
              <span className="absolute -top-2 -left-2 w-5 h-5 border-t-2 border-l-2 border-cyanbrand" aria-hidden="true" />
              <span className="absolute -bottom-2 -right-2 w-5 h-5 border-b-2 border-r-2 border-mag" aria-hidden="true" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
